import { useBoolean } from "@/hooks/useBoolean";
import { useTranslations } from "@/i18n/client";
import type { ChangeEvent, FormEvent } from "react";
import { useEffect, useState } from "react";

import Button from "@/components/ui/Button";
import Modal from "@/components/ui/Modal";
import { PATHS } from "@/consts";
import Checkbox from "@/features/checkout/Checkbox";
import useModal from "@/hooks/useModal";
import { useRichText } from "@/hooks/useRichText";
import { Link } from "@/i18n/routing";
import useLocation from "@/lib/centra/hooks/useLocation";
import clsx from "clsx";
import isEqual from "lodash.isequal";
import styles from "./index.module.css";

const NotifyComingSoon = ({
  item,
}: {
  item?: { itemId: string; stock: boolean };
}) => {
  const { rich } = useRichText();
  const t = useTranslations();
  const [email, setEmail] = useState("");
  const checkboxState = useBoolean(false);
  const location = useLocation();
  const [locationState, setLocationState] = useState(location.state);
  const [country, setCountry] = useState(location.location);
  const [result, setResult] = useState(false);
  const { closeModal, isOpen } = useModal(COMING_SOON_MODAL_KEY, {
    _lock: true,
    popover: false,
  });

  useEffect(() => {
    if (!isOpen) {
      setResult(false);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isEqual(location.location, country)) {
      return;
    }
    setCountry(location.location);
    setLocationState(location.state);
  }, [location, country]);

  const notifyMeComingSoon = async (e: FormEvent) => {
    e.preventDefault();
    const apiUrl = process.env.NEXT_PUBLIC_CENTRA_CHECKOUT;
    const res = await fetch(`${apiUrl}/newsletter-subscription`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        country: country,
        item: item?.itemId,
      }),
    });
    const json = await res.json();
    setResult(json.subscribed);
  };

  // const notifyMeStock = async (e: FormEvent) => {
  //   e.preventDefault();
  //   if (checkboxState.value) {
  //     notifyMeComingSoon();
  //   }
  //   const apiUrl = process.env.NEXT_PUBLIC_CENTRA_CHECKOUT;
  //   const res = await fetch(`${apiUrl}/back-in-stock-subscription`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({
  //       email: email,
  //       shipTo: {
  //         country: country,
  //         state: locationState,
  //       },
  //       item: item?.itemId,
  //     }),
  //   });
  //   const json = await res.json();
  //   setResult(!!json.token);
  // };

  const toggleCheckboxState = (_e: ChangeEvent<HTMLInputElement>) => {
    checkboxState.toggle();
  };

  return (
    <Modal title={" "} modal={COMING_SOON_MODAL_KEY} always>
      <div className={styles.inner}>
        {!result ? (
          <>
            <h2>Coming soon</h2>
            <p className={styles.ingress}>{t("checkout.comingSoon")}</p>
            <form onSubmit={notifyMeComingSoon}>
              <div className={styles["inputs"]}>
                <input type="hidden" name="_country" value={country ?? 0} />
                <input type="hidden" name="_item" value={item?.itemId ?? 0} />
                <input type="hidden" name="_state" value={locationState ?? 0} />
                <input
                  type="email"
                  placeholder="Your e-mail"
                  id="coming-soon-email"
                  name="email"
                  autoComplete="email"
                  value={email}
                  required
                  onChange={e => setEmail(e.target.value)}
                />
              </div>
              <div className={styles["modal-button-container"]}>
                <Button
                  onClick={() => console.log("pressed")}
                  type="submit"
                  className="uppercase"
                >
                  Notify me
                </Button>
              </div>
              <div className={styles.checkbox}>
                <Checkbox
                  label={rich(t("comingSoon.newsletter"), {
                    link: chunks => (
                      <Link key={1} href={PATHS.privacyPolicy}>
                        {chunks}
                      </Link>
                    ),
                  })}
                  checked={checkboxState.value}
                  onChange={toggleCheckboxState}
                />
              </div>
            </form>
          </>
        ) : (
          <>
            <h2 className={clsx(styles["text-center"])}>
              {t("comingSoon.title")}
            </h2>
            <p className={clsx(styles["text-center"])}>
              {t("comingSoon.text")}
            </p>
            <Button onClick={closeModal}>{t("comingSoon.back")}</Button>
          </>
        )}
      </div>
    </Modal>
  );
};

export default NotifyComingSoon;

export const COMING_SOON_MODAL_KEY = "notify-coming-soon";
